import { ref } from "vue";
import { defineStore } from "pinia";
import axios, { AxiosRequestConfig } from "axios";

type StoreRequestParams = {
    with?: string[]
    signal?: AbortSignal
};

export function createEntityStore<T extends {
    id: number;
}>(entityName: string, apiEndpoint: string) {
    return defineStore(`${entityName}Store`, () => {
        const entity = ref<T | null>(null);

        const clean = () => {
            entity.value = null;
        };

        const update = async (updatedEntity: T) => {
            const { data } = await axios.patch(`${apiEndpoint}/${updatedEntity.id}`, updatedEntity);

            entity.value = data.data;
        };

        const get = async (id: number, params?: StoreRequestParams) => {
            const requestParams: AxiosRequestConfig["params"] = {};

            if (params?.with) {
                requestParams.with = params.with.join(",");
            }

            const data  = await axios.get(`${apiEndpoint}/${id}`, {
                params: requestParams,
                signal: params?.signal
            });

            entity.value = data.data;
        };

        return {
            entity,
            get,
            update,
            clean
        };
    });
}
